import * as Tabs from '@radix-ui/react-tabs'
// import PhilosophyTab from './PhilosophyTab'
import TypographyTab from './TypographyTab'
import ColorTab from './ColorTab'
// import NotesTab from './NotesTab'

const TAB_TRIGGER = 'pb-3 text-sm font-semibold text-fg-secondary hover:text-fg transition-colors data-[state=active]:text-fg data-[state=active]:border-b-2 data-[state=active]:border-fg data-[state=active]:-mb-px outline-none cursor-pointer'

export default function DesignGuide() {
  return (
    <div className="min-h-screen bg-canvas text-fg">
      <div className="mx-auto max-w-6xl px-8 py-14">

        {/* Page header */}
        <div className="pb-8">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-fg-secondary">Design Guide</p>
        </div>

        <Tabs.Root defaultValue="color">
          <Tabs.List className="flex gap-8 border-b border-line mb-12">
            {/* <Tabs.Trigger value="philosophy" className={TAB_TRIGGER}>Philosophy</Tabs.Trigger> */}
            <Tabs.Trigger value="typography" className={TAB_TRIGGER}>Typography</Tabs.Trigger>
            <Tabs.Trigger value="color" className={TAB_TRIGGER}>Color</Tabs.Trigger>
            {/* <Tabs.Trigger value="notes" className={TAB_TRIGGER}>Notes</Tabs.Trigger> */}
          </Tabs.List>

          {/* <PhilosophyTab /> */}
          <TypographyTab />
          <ColorTab />
          {/* <NotesTab /> */}
        </Tabs.Root>

      </div>
    </div>
  )
}
